const images = [
    {
        image: require("../web_elements/toploizolaciya_slideshow_01.png"),
        subtitle: "Топлоизолация",
    },
    {
        image: require("../web_elements/doklyuch_slideshow_02.png"),
        subtitle: "Довършителни работи",
    },
    {
        image: require("../web_elements/remontpokrivi_slideshow_03.png"),
        subtitle: "Ремонт и хидроизолация на покриви",
    },
    {
        image: require("../web_elements/gofraj_slideshow_04.png"),
        subtitle: "Кофражна работа и зидария",
    },
    {
        image: require("../web_elements/podove_slideshow_05.png"),
        subtitle: "Полагане на подови настилки и замазка",
    },
    {
        image: require("../web_elements/elivik_slideshow_06.png"),
        subtitle: "Ел. и ВиК услуги",
    },
    {
        image: require("../web_elements/pochistvane_slideshow_07.png"),
        subtitle: "Професионално почистване",
    },
    {
        image: require("../web_elements/shpaklovki_slideshow_08.png"),
        subtitle: "Шпакловане и боядисване",
    },
    {
        image: require("../web_elements/planirane_slideshow_09.png"),
        subtitle: "Планиране",
    },
    {
        image: require("../web_elements/dograma_slideshow_10.png"),
        subtitle: "Монтаж на дограма",
    },
    {
        image: require("../web_elements/metalni_konstrukcii.png"),
        subtitle: "Ментални конструкции",
    },
    //{
    //    image: require("../web_elements/metalni_konstrukcii.png"),
    //    subtitle: "Мебелировка",
    //},
];

export default images;
